if (!customElements.get('segment-promo-banner')) {
  customElements.define(
    'segment-promo-banner',
    class SegmentPromoBanner extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.closeButton = this.querySelector('[data-spb-close]');
        this.copyButtons = this.querySelectorAll('[data-spb-copy]');
        this.copyHints = this.querySelectorAll('[data-spb-copy-hint]');
        this.liveRegion = this.querySelector('[data-spb-copied]');

        this.closeButton?.addEventListener('click', () => this.dismiss());
        this.copyButtons.forEach((button) => {
          button.addEventListener('click', () => this.copyCode());
        });

        if (Shopify.designMode || this.testMode) {
          this.hidden = false;
          return;
        }

        if (this.getCookie(this.cookieName)) {
          this.remove();
        }
      }

      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }

      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry'), 10) : 14;
      }

      get cookieName() {
        return this.getAttribute('data-cookie') || 'bracarli:segment-promo';
      }

      get code() {
        return this.getAttribute('data-code') || '';
      }

      get copyLabel() {
        return this.getAttribute('data-copy-label') || 'tocar';
      }

      get copiedLabel() {
        return this.getAttribute('data-copied-label') || 'copiado';
      }

      dismiss() {
        if (!this.testMode) {
          this.setCookie(this.cookieName, this.expiry);
        } else {
          this.removeCookie(this.cookieName);
        }

        this.setAttribute('hidden', '');
        window.setTimeout(() => this.remove(), 180);
      }

      async copyCode() {
        const code = this.code;
        if (!code) return;

        try {
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(code);
          } else {
            const input = document.createElement('textarea');
            input.value = code;
            input.setAttribute('readonly', '');
            input.style.position = 'absolute';
            input.style.left = '-9999px';
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
          }

          this.copyButtons.forEach((button) => button.classList.add('is-copied'));
          this.copyHints.forEach((hint) => {
            hint.textContent = this.copiedLabel;
          });
          if (this.liveRegion) this.liveRegion.textContent = this.copiedLabel;

          window.clearTimeout(this.copiedTimer);
          this.copiedTimer = window.setTimeout(() => {
            this.copyButtons.forEach((button) => button.classList.remove('is-copied'));
            this.copyHints.forEach((hint) => {
              hint.textContent = this.copyLabel;
            });
          }, 1800);
        } catch (error) {
          console.warn('No se pudo copiar el código', error);
        }
      }

      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }

      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${expiry * 24 * 60 * 60}; path=/`;
      }

      removeCookie(name) {
        document.cookie = `${name}=; max-age=0; path=/`;
      }
    }
  );
}
